module.exports = __webpack_public_path__ + "static/img/ic_boleto.a42abd40.svg";